function module(name, callback){
  var template = document.querySelectorAll('*[data-module=' + name + ']');
  if ( template.length === 1 ){
    module[name] = ( callback.bind(template) )();
  } else {
    module[name] = [];
    for (var i = 0; i < template.length; i++){
      module[name][i] = ( callback.bind(template[i]) )();
    }
  }
}

var a2a_config = a2a_config || {};
a2a_config.templates = a2a_config.templates || {};

a2a_config.templates.email = {
  subject: "Heb je deze interessante vacature bij ARAG gezien? ${title}",
  body: "Graag deel ik deze interessante vacature bij ARAG met jou. Lees snel meer (en reageer)!\n\n ${title}\n ${link}\n\n Ps. wil je de vacatures van ARAG direct in je mail ontvangen? Maak een jobalert aan! https://werkenbijarag.nl/jobalert",
};

a2a_config.templates.whatsapp = {
  text: "Heb je deze interessante vacature bij ARAG gezien? ${title} ${link}",
};

function checkElementLocation() {
  let $window = jQuery(window);
  let bottomOfWindow = $window.scrollTop() + $window.height();

  jQuery('.fader').each(function(i) {
    let $that = jQuery(this);
    let startFadePosition = $that.position().top + 10;

    // if element is in viewport, add the fader animation class
    if (bottomOfWindow > startFadePosition) {
      jQuery(this).addClass('in');
    }
  });
}

jQuery(document).ready(function($) {
  // if in viewport, show the animation
  checkElementLocation();

  $(window).on('scroll', function() {
    checkElementLocation();
  });

  $('.header_mobile-menu-button').click(function() {
    $('.mobile-menu').animate({right: '0%'}, 300, function() {
      $(this).addClass('-opened');
    });
  });
  $('.mobile-menu_close').click(function() {
    $('.mobile-menu').animate({right: '100%'}, 300, function() {
      $(this).removeClass('-opened');
    });
  });

  $('.accordion-item_title').click(function() {
    $(this).parent().find('.accordion-item_content').slideToggle(300);
    $(this).parent().toggleClass('-opened');
  });

  $('.lane_video-overlay').click(function() {
    $(this).fadeOut(300);
    var $laneVideoContainer = $(this).parent();
    var video = $laneVideoContainer.find('video')[0];
    video.play();
  });

  $('.slider').each(function(index) {
    $(this).find('.swiper-button-next').addClass('swiper-button-next-' + index);
    $(this).find('.swiper-button-prev').addClass('swiper-button-prev-' + index);
    new Swiper(this, {
      slidesPerView: 1,
      loop: true,
      autoHeight: true,
      // autoplay: {
      //   delay: 3000,
      //   pauseOnMouseEnter: true
      // },
      navigation: {
        nextEl: '.swiper-button-next-' + index,
        prevEl: '.swiper-button-prev-' + index,
      },
    })
  });

  $('.block-vacatures_list').each(function(index) {
    $(this).parent().find('.block-vacatures_prev').addClass('vacatures-prev-' + index);
    $(this).parent().find('.block-vacatures_next').addClass('vacatures-next-' + index);
    new Swiper(this, {
      loop: true,
      autoHeight: true,
      spaceBetween: 20,
      navigation: {
        nextEl: '.vacatures-next-' + index,
        prevEl: '.vacatures-prev-' + index,
      },
      breakpoints: {
        950: {
          slidesPerView: 3,
        },
        750: {
          slidesPerView: 2,
        }
      }
    })
  });

  if ($('.template-vacatures').length) {
    var $selectedFilters = $('.vacatures-filters_selected-list');

    $('.vacatures-filters_item').click(function() {
      var filterName = $(this).attr('data-filter');

      if ($(this).hasClass('-opened')) {
        $(this).removeClass('-opened');
        $('.vacatures-filters_options-list[data-filter="'+ filterName +'"]').slideUp();
      } else {
        $('.vacatures-filters_item').removeClass('-opened');
        $('.vacatures-filters_options-list').slideUp();

        $(this).addClass('-opened');
        $('.vacatures-filters_options-list[data-filter="'+ filterName +'"]').slideDown();
      }
    });

    var vacaturesList = $('.vacatures-list').isotope({
      itemSelector: '.vacatures-item',
      layoutMode: 'fitRows',
      transitionDuration: 300,
      getSortData: {
        name: function(item) {
          return $(item).data('sort-name');
        },
        date: function(item) {
          return new Date($(item).data('sort-date'));
        }
      }
    });

    function getActiveVacaturesFilters() {
      var activeFilters = {};
      $('.vacatures-filters_selected-list').find('.vacatures-filters_selected-item').each(function() {
        var filterName = $(this).data('filter');
        var filterValue = $(this).data('filter-value') + '';

        if (!activeFilters[filterName]) {
          activeFilters[filterName] = [];
        }
        activeFilters[filterName].push(filterValue);
      });

      return activeFilters;
    }

    function applyVacaturesFilters() {
      var filters = getActiveVacaturesFilters();
      var matchedCount = 0;

      var url = new URL(window.location.href);
      for (var [paramName, paramValue] of url.searchParams) {
        url.searchParams.delete(paramName);
      }
      Object.entries(filters).forEach(function(entry) {
        var [filterName, filterValue] = entry;
        url.searchParams.delete(filterName);
        url.searchParams.set(filterName, filterValue.join(','));
      });
      window.history.replaceState(null, null, url);

      vacaturesList.isotope({
        filter: function(item) {
          var $self = $(this);
          var matched = true;

          Object.entries(filters).forEach(function(entry) {
            var [filterName, filterValue] = entry;
            if (filterName === 'search') {
              if (!$self.data('filter-search').toLowerCase().includes(filterValue[0].toLowerCase())) {
                matched = false;
                return;
              }
            } else if (filterName === 'locatie') {
              var locaties = $self.data('filter-' + filterName).split(',');
              var locatieMatch = false;
              for (var i = 0; i < locaties.length; i++) {
                if (filterValue.includes(locaties[i])) {
                  locatieMatch = true;
                }
              }
              if (!locatieMatch) {
                matched = false;
                return;
              }
            } else {
              if (!filterValue.includes($self.data('filter-' + filterName))) {
                matched = false;
                return;
              }
            }
          });

          if (matched){
            matchedCount++;
          }

          return matched;
        }
      });
      $('.vacatures-count span').html(matchedCount);
      if (matchedCount === 0) {
        $('.no-vacatures-found').fadeIn(300);
      } else {
        $('.no-vacatures-found').hide();
      }
    }

    $('.vacatures-filters_options-item').click(function() {
      var filter = $(this).parent().data('filter');
      var value = $(this).data('filter-value');

      if ($(this).hasClass('-selected')) {
        $(this).removeClass('-selected');
        $selectedFilters.find('[data-filter="'+filter+'"][data-filter-value="'+value+'"]').remove();
      } else {
        $(this).addClass('-selected');
        $selectedFilters.append('<div class="vacatures-filters_selected-item" data-filter="'+filter+'" data-filter-value="'+value+'">' + value + '</div>');
      }

      applyVacaturesFilters();
    });

    $('.vacatures-filters_selected-list').click(function(e) {
      if ($(e.target).hasClass('vacatures-filters_selected-item')) {
        var filter = $(e.target).data('filter');
        var value = $(e.target).data('filter-value');
        if (filter !== 'search') {
          $('.vacatures-filters_options-list[data-filter="'+filter+'"] .vacatures-filters_options-item[data-filter-value="'+value+'"]').removeClass('-selected');
        } else {
          $('.vacatures-filters_search input[type=text]').val('');
        }
        $(e.target).remove();
        applyVacaturesFilters()
      }
    });

    $('.vacatures-filters_search').submit(function(e) {
      e.preventDefault();
      var searchValue = $('.vacatures-filters_search input[type=text]').val();
      if (searchValue.length > 0) {
        $selectedFilters.append('<div class="vacatures-filters_selected-item" data-filter="search" data-filter-value="'+searchValue+'">' + searchValue + '</div>');
      }
      applyVacaturesFilters();
      return false;
    });

    function sortVacatures() {
      var value = $('.vacatures-sort-select').val().split('|'),
        sortBy = value[0],
        sortAscending = value[1] === 'asc';

      vacaturesList.isotope({sortBy: sortBy, sortAscending: sortAscending});
    }
    sortVacatures();

    $('.vacatures-sort-select').on('change', function() {
      sortVacatures();
    });

    var url = new URL(window.location.href);
    if (url.searchParams.size > 0) {
      for (var [paramName, paramValue] of url.searchParams) {
        var values = paramValue.split(',');

        for (var i = 0; i < values.length; i++) {
          if (paramName === 'search') {
            $('.vacatures-filters_search input[type=text]').val(values[i]);
            $selectedFilters.append('<div class="vacatures-filters_selected-item" data-filter="search" data-filter-value="'+values[i]+'">' + values[i] + '</div>');
          } else {
            var $filter = $('.vacatures-filters_options-list[data-filter="'+paramName+'"] .vacatures-filters_options-item[data-filter-value="'+values[i]+'"]');
            if ($filter.length > 0) {
              $filter.addClass('-selected');
              $selectedFilters.append('<div class="vacatures-filters_selected-item" data-filter="'+paramName+'" data-filter-value="'+values[i]+'">' + values[i] + '</div>');
            }
          }
        }
      }
      applyVacaturesFilters();
    }
  }
});
